module.exports = "<router-outlet></router-outlet>\r\n<app-navi></app-navi>\r\n"